import React, { useState, useEffect } from "react";

import './Thematic.css';

import { SvgClose, SvgImg } from "components/SvgFile";

import { GetUserData } from "interface/Users";
import { SetModalState, RegisterModalData, RegisterModalObserver, SetModalData } from "interface/PopUp";

export default function PopUP_Thematic(props){

    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    const [ name, setName ]     = useState('');

    useEffect(()=>{
        RegisterModalData('Thematic', setModaldata);
        RegisterModalObserver('Thematic', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(showPopUp == true){
        }
    }, [showPopUp]);

    function SaveData(){
        ClosePopUp();
    }

    function ClosePopUp(){
        SetModalState('Thematic', false);
    }

    return (
        (showPopUp ?
            <>
                <div className="PopUp">
                    <div className="all popup_profile">
                        <div className="div_data type_div">
                            <div className="title">
                                Adicionar nova temática
                            </div>
                            <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                                <SvgClose color="#F00000" className="icons" />
                            </div>
                        </div>
                        <div className="div_data" style={ { paddingTop: 0 } }>
                            <div className="content">
                                <div className="list_input_data">
                                    <div className="div_input space_width" style={ { flexGrow: 1 } }>
                                        <input type="text" className="space_width" onChange={ (e)=>{ setName(e.target.value); props.RegThematic(e.target.value) } } value={ name } maxLength="140" />
                                        <span className="name_input">Nome</span>
                                    </div>
                                </div>
                                <div className="register_data button_category" onClick={ ()=>{ SaveData() } }>
                                    Cadastrar
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        : <React.Fragment></React.Fragment>)
    );
}
